import { BugReportRequest } from "../@types/Bug";
import { create } from "../services/bug/report";

export default function useBug() {
  async function createReport(data: BugReportRequest): Promise<boolean> {
    const status = await create(data);

    if (status === 201) {
      return true;
    }

    return false;
  }

  return {
    createReport,
  };
}
